/*
 * Copyright (C) 2019-present Arctic Ice Studio <development@arcticicestudio.com>
 * Copyright (C) 2019-present Sven Greb <development@svengreb.de>
 *
 * Project:    Arctic Ocean Fractal
 * Repository: https://github.com/arcticicestudio/arctic-ocean-fractal
 * License:    MIT
 */

/**
 * @file Provides shared constants.
 * @author Arctic Ice Studio <development@arcticicestudio.com>
 * @author Sven Greb <development@svengreb.de>
 * @since 0.1.0
 */

/**
 * The name of the pose to trigger the hiding animation.
 *
 * @since 0.1.0
 */
const POSE_HIDE = "hide";

/**
 * The name of the pose to trigger the show animation.
 *
 * @since 0.1.0
 */
const POSE_SHOW = "show";

export { POSE_HIDE, POSE_SHOW };
